import * as constants from './constants';

export const getBarcodeCategories = (payload) => ({ type: constants.GET_BARCODE_CATEGORIES, payload });
export const resetBarcodeCategories = () => ({ type: constants.RESET_BARCODE_CATEGORIES });
export const getBarcodeCategoriesSuccess = (payload) => ({
  type: constants.GET_BARCODE_CATEGORIES_SUCCESS,
  payload,
});
export const getBarcodeCategoriessError = (payload) => ({
  type: constants.GET_BARCODE_CATEGORIES_ERROR,
  payload,
});

export const getUserBarcodeCategories = () => ({ type: constants.GET_USER_BARCODE_CATEGORIES });
export const getUserBarcodeCategoriesSuccess = (payload) => ({
  type: constants.GET_USER_BARCODE_CATEGORIES_SUCCESS,
  payload,
});
export const getUserBarcodeCategoriesError = (payload) => ({
  type: constants.GET_USER_BARCODE_CATEGORIES_ERROR,
  payload,
});
export const resetUserBarcodeCategories = () => ({ type: constants.RESET_USER_BARCODE_CATEGORIES });

export const addUserCategory = (payload) => ({ type: constants.ADD_USER_CATEGORY, payload });
export const addUserCategorySuccess = () => ({
  type: constants.ADD_USER_CATEGORY_SUCCESS,
});
export const addUserCategoryError = (payload) => ({
  type: constants.ADD_USER_CATEGORY_ERROR,
  payload,
});

// eslint-disable-next-line max-len
export const removeUserCategory = (payload) => ({ type: constants.REMOVE_USER_CATEGORY, payload });
export const removeUserCategorySuccess = () => ({
  type: constants.REMOVE_USER_CATEGORY_SUCCESS,
});
export const removeUserCategoryError = (payload) => ({
  type: constants.REMOVE_USER_CATEGORY_ERROR,
  payload,
});
